<template>
  <q-page class="q-pa-sm">
    <div class="row q-col-gutter-sm">
      <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
        <q-card class="card-bg no-shadow" bordered>
          <q-form ref="form" @reset="onReset" @submit="onSave">
            <q-card-section class="card-bg-title">
              <div class="text-h6">Add Password</div>
            </q-card-section>
            <q-card-section class="q-pa-lg">
              <div class="row q-col-gutter-md">
                <q-item class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <q-item-section>
                    <q-input
                      v-model="formData.name"
                      :rules="[(val) => (val && val.length > 0) || $t('errTypeSomething')]"
                      filled
                      :placeholder="$t('entryName')"
                      lazy-rules
                      bordered
                      dense
                      dark
                      q-input
                      bottom-slots
                    />
                  </q-item-section>
                </q-item>
                <q-item class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <q-item-section>
                    <q-input
                      v-model="formData.url"
                      filled
                      :placeholder="$t('Url')"
                      lazy-rules
                      bordered
                      dense
                      dark
                      q-input
                      bottom-slots
                    />
                  </q-item-section>
                </q-item>
                <q-item class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <q-item-section>
                    <q-input
                      v-model="formData.username"
                      filled
                      :placeholder="$t('Username')"
                      lazy-rules
                      bordered
                      dense
                      dark
                      q-input
                      bottom-slots
                    />
                  </q-item-section>
                </q-item>
                <q-item v-if="!formData.generated" class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <q-item-section>
                    <q-input
                      v-model="formData.password"
                      filled
                      :placeholder="$t('Password')"
                      lazy-rules
                      bordered
                      dense
                      dark
                      :type="isPwd ? 'password' : 'text'"
                      q-input
                      bottom-slots
                    >
                      <template v-slot:append>
                        <q-icon
                          :name="isPwd ? 'mdi-eye-off' : 'mdi-eye'"
                          mdi
                          class="cursor-pointer"
                          @click="isPwd = !isPwd"
                        />
                      </template>
                    </q-input>
                  </q-item-section>
                </q-item>
              </div>
              <div class="row q-col-gutter-md">
                <q-item class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <q-item-section>
                    <q-toggle
                      v-model="formData.generated"
                      :label="$t('generated')"
                      bottom-slots
                    />
                  </q-item-section>
                </q-item>
                <q-item class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <q-item-section>
                    <q-input
                      v-model="formData.comment"
                      filled
                      :placeholder="$t('Comment')"
                      type="textarea"
                      lazy-rules
                      bordered
                      dense
                      dark
                      q-input
                      bottom-slots
                    />
                  </q-item-section>
                </q-item>
              </div>
            </q-card-section>
            <q-card-actions align="left" class="q-pl-lg">
              <q-btn color="primary" :label="$t('add')" type="submit" />
              <q-btn class="q-ml-sm" flat :label="$t('reset')" type="reset" />
            </q-card-actions>
          </q-form>
        </q-card>
      </div>
      <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12">
        <q-card class="card-bg no-shadow" bordered>
          <q-card-section class="card-bg-title">
            <div class="text-h6">{{ $t('PasswordList') }}</div>
          </q-card-section>
          <q-table
            class="sticky-table-header row"

            ref="tableRef"
            row-key="index"
            selection="multiple"

            v-model:selected="selected"
            v-model:pagination="pagination"

            binary-state-sort flat bordered virtual-scroll

            :grid="$q.screen.xs"
            :rows="rows"
            :columns="Pass.columns"
            :loading="loading"
            :visible-columns="Pass.visible"

            :virtual-scroll-item-size="itemSize"
            :virtual-scroll-sticky-size-start="itemSize"
            :rows-per-page-options="[0]"

            @virtual-scroll="onScroll"
          >
            <template v-slot:body="props">
              <q-tr :props="props" @click="prompt">
                <q-td>
                  <q-checkbox v-model="props.selected" />
                </q-td>
                <q-td v-for="(col) in props.cols" :key="col.field" :props="props">
                  {{ props.row[ col.field ] }}
                </q-td>
              </q-tr>
            </template>
            <template v-slot:top>
              <q-btn v-if="rows.length !== 0" class="q-ml-sm" color="secondary" filled
                     :disable="loading || selected.length == 0"
                     :label="$t(`remove.row${selected.length > 1?'s':''}`)"
                     @click="onRemove" />
              <q-space />
              <q-input borderless dense debounce="300" color="secondary" filled v-model="filter">
                <template v-slot:append>
                  <q-icon name="mdi-magnify" color="white" />
                </template>
              </q-input>
            </template>
          </q-table>
        </q-card>
      </div>
      <q-dialog v-model="prompt">
        <q-card style="min-width: 350px">
          <q-card-section>
            <div class="text-h6">Your address</div>
          </q-card-section>

          <q-card-section class="q-pt-none">

          </q-card-section>

          <q-card-actions align="right" class="text-primary">
            <q-btn flat label="Cancel" v-close-popup />
            <q-btn flat label="Add address" v-close-popup />
          </q-card-actions>
        </q-card>
      </q-dialog>
    </div>
  </q-page>
</template>

<script lang="ts" setup>
import { QForm, type QTable, useQuasar } from 'quasar';
import { onMounted, reactive, type Ref, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import type { Pagination, Scroll } from '@/types/option';
import { Reset } from '@/service';
import { Delete, Load, Pass, Submit } from '@/service/pass';
import type { AddPasswordFormData } from '@/types/request';

const $q = useQuasar();
const { t } = useI18n();
const $t = t;

const pageSize = 20;
const itemSize = 48;

const prompt = ref(false);
const tableRef = ref() as Ref<QTable>;
const loading = ref(false);
const loaded = ref(false);
const rows = ref([]);
const selected = ref([]);
const filter = ref('');
const pagination = ref({ rowsPerPage: 0, rowsNumber: 0 } as Pagination);

const form = ref() as Ref<QForm>;
const formData = reactive(<AddPasswordFormData>{});

const isPwd = ref(true);

const onReset = () => {
  Reset(formData);
};
const onSave = () => {
  Submit(formData).then(response).catch(error);
};

const onScroll = async (scroll: Scroll) => {
  await Load(rows, pagination, loading, loaded, pageSize, false, scroll);
};

const onRemove = async () => {
  await Delete(selected.value, loading).then(response).catch(error);
};

onMounted(async () => {
  await Load(rows, pagination, loading, loaded, pageSize, true);
});

async function reload() {
  loaded.value = false;
  rows.value = [];
  pagination.value.lastId = null;
  await Load(rows, pagination, loading, loaded, pageSize, true);
  tableRef.value.resetVirtualScroll();
}

async function response(response: Response) {
  if (!response.ok) {
    return Promise.reject(Error(response.statusText));
  }
  $q.notify({
    color: 'green-4',
    icon: 'mdi-check-circle',
    message: $t('successful.saved')
  });
  await reload();
}

async function error(error: Error) {
  $q.notify({
    color: 'red-4',
    icon: 'mdi-alert-circle',
    message: $t(error.toString())
  });
  await reload();
}
</script>
